import type { ScrollToProps } from '@/components/success-gambling/components/scroll-to/scroll-to.types';
import '@/components/success-gambling/components/scroll-to/scroll-to.css';

export default function ScrollTo(props: ScrollToProps) {
  const { onClick } = props;

  return (
    <div className='success-gambling-scroll-to'>
      Falls der Klick nicht Ihre bevorzugte Mail-App öffnet, probieren Sie{' '}
      <button
        data-testid='gambling-scroll-button'
        type='button'
        aria-label='scroll'
        className='success-gambling-scroll-to__button'
        onClick={() => onClick()}
      >
        unsere Alternative
      </button>{' '}
      weiter unten.
    </div>
  );
}
